import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link, useNavigate } from 'react-router-dom';
import { FaRegClock, FaGlobe } from 'react-icons/fa';
import  oman from "../assets/arisa-s-EtJBt_QLY94-unsplash.jpg"
import uae from "../assets/roman-logov-jomuw0-3F8A-unsplash.jpg"
import india from "../assets/julian-yu-_WuPjE-MPHo-unsplash.jpg"
import usa from "../assets/jenna-day-UM8bURrginM-unsplash.jpg"
import europe from "../assets/frederic-koberl-kD4RV6_EtRA-unsplash.jpg"

const VisaAssistance = () => {
  const navigate = useNavigate();

const visaPackages = [
  /* ---------------------------------------------------------
     SULTANATE OF OMAN
  --------------------------------------------------------- */
  {
    country: "SULTANATE OF OMAN",
    image:
     oman,
    alt: "Oman Fort",
    visas: [
      {
        title: "Tourist Visa - 10 Days Single Entry",
        type: "eVISA",
        stay: "10 Days",
        validity: "90 Days",
        processing: "24 Hours",
      },
      {
        title: "Tourist Visa - 30 Days Single Entry",
        type: "eVISA",
        stay: "30 Days",
        validity: "90 Days",
        processing: "24 Hours",
      },
    ],
    document: [
      "Clear picture of passport front page and back page.",
      "Color photo with white background.",
    ],
    note: [
      "A minor visa must be applied along with the parent visa only.",
      "Birth Certificate is required for minors.",
    ],
  },

  /* ---------------------------------------------------------
     UNITED ARAB EMIRATES
  --------------------------------------------------------- */
  {
    country: "UNITED ARAB EMIRATES",
    image:
      uae,
    alt: "Dubai Skyline",
    visas: [
      {
        title: "Tourist Visa - 30 Days Single Entry",
        type: "eVISA",
        stay: "30 Days",
        validity: "60 Days",
        processing: "3-5 Days",
      },
      {
        title: "Tourist Visa - 30 Days Single Entry Express",
        type: "eVISA",
        stay: "30 Days",
        validity: "60 Days",
        processing: "24 Hours",
      },
      {
        title: "Tourist Visa - 30 Days Multiple Entry",
        type: "eVISA",
        stay: "30 Days",
        validity: "60 Days",
        processing: "3-5 Days",
      },
      {
        title: "Tourist Visa - 30 Days Multiple Entry Express",
        type: "eVISA",
        stay: "30 Days",
        validity: "60 Days",
        processing: "2 Days",
      },
      {
        title: "Tourist Visa - 60 Days Single Entry",
        type: "eVISA",
        stay: "60 Days",
        validity: "60 Days",
        processing: "3-4 Days",
      },
      {
        title: "Tourist Visa - 60 Days Multiple Entry",
        type: "eVISA",
        stay: "60 Days",
        validity: "60 Days",
        processing: "3-5 Hours",
      },
      {
        title: "Tourist Visa - 60 Days Multiple Entry Express",
        type: "eVISA",
        stay: "60 Days",
        validity: "60 Days",
        processing: "24 Hours",
      },
    ],
    document: [
      "Clear picture of passport front page and back page.",
      "Color photo with white background.",
      "Round trip flight tickets.",
      "Confirmed hotel bookings.",
    ],
    note: [
      "A minor visa must be applied along with the parent visa only.",
      "Birth Certificate is required for minors.",
    ],
  },

  /* ---------------------------------------------------------
     INDIA
  --------------------------------------------------------- */
  {
    country: "INDIA",
    image:
      india,
    alt: "India",
    visas: [
      {
        title: "Tourist Visa - 30 Days Single Entry",
        entries: "Double Entry",
        type: "eVISA",
        stay: "30 Days",
        validity: "60 Days",
        processing: "3 Working Days",
      },
      {
        title: "Tourist Visa - One Year Multiple Entry",
        entries: "Multiple",
        type: "eVISA",
        stay: "Not more than 180 days",
        validity: "365 Days",
        processing: "3 Working Days",
      },
      {
        title: "Tourist Visa - Five Year Multiple Entry",
        entries: "Multiple",
        type: "eVISA",
        stay: "Not more than 180 days per year",
        validity: "5 Years",
        processing: "3 Working Days",
      },
      {
        title: "e-Medical Visa",
        entries: "Triple",
        type: "eVISA",
        stay: "60 Days",
        validity: "60 Days",
        processing: "3 Working Days",
      },
      {
        title: "e-Medical Attendant Visa",
        entries: "Triple",
        type: "eVISA",
        stay: "60 Days",
        validity: "60 Days",
        processing: "3 Working Days",
      },
    ],
    document: [
      "Clear picture of passport front page and back page.",
      "Color photo with white background.",
      "Medical Report (for medical visa).",
      "Invitation letter from hospital (for medical visa).",
    ],
    note: [
      "Maximum stay in India in a calendar year must not exceed 180 days for 1-year and 5-year Tourist Visa.",
    ],
  },

  /* ---------------------------------------------------------
     UNITED STATES OF AMERICA
  --------------------------------------------------------- */
  {
    country: "UNITED STATES OF AMERICA",
    image:
      usa,
    alt: "USA",
    visas: [
      {
        title: "Tourist Visa - B1/B2",
        type: "Sticker",
        stay: "6 Months",
        validity: "10 Years",
        processing: "2-3 Days",
      },
    ],
    document: [
      "Clear picture of passport front page and back page.",
      "Old passport (if any).",
      "Resident card (if any).",
      "Recent photograph 2x2 inch, white background, without specs.",
      "Company registration license (if self-employed).",
    ],
    note: [
      "A minor visa must be applied along with the parent visa.",
      "Birth Certificate is required for minors.",
    ],
  },

  /* ---------------------------------------------------------
     EUROPEAN UNION (SCHENGEN)
  --------------------------------------------------------- */
  {
    country: "EUROPEAN UNION",
    image:
      europe,
    alt: "European Union",
    visas: [
      {
        title: "Tourist / Business Visa (6 Months) - Single/Multi Entry",
        type: "Sticker",
        stay: "90 Days",
        processing: "1 Day",
      },
    ],
    document: [
      "Clear picture of passport front page and back page.",
      "Old passport (if any).",
      "Resident card (if any).",
      "Recent photograph 2x2 inch, white background, without specs.",
      "Company registration license (if self-employed).",
      "Sponsor NOC Letter (if non-Omani).",
      "Last 6 months bank statements.",
    ],
    note: [
      "For minors travelling with one parent or a third party: notarized and legalized affidavit is required.",
      "If parent resides in Italy, a self-declaration plus passport and residency copies authenticated by the Commune is required.",
      "Parents can also sign consent at the Consulate General of Italy with IDs and birth certificate.",
    ],
  },
];

  useEffect(() => {
    if ('scrollRestoration' in window.history) window.history.scrollRestoration = 'manual';
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, []);

  return (
    <section className="container py-16">
      <div className="text-center mb-12">
        <h2 className="text-3xl md:text-5xl font-bold">Visa Assistance</h2>
        <p className="text-gray-600 mt-2 max-w-3xl mx-auto font-bold">
         Discover the World's Hidden Gems with one zone travels
        </p>
         <p className="text-gray-600 mt-2 max-w-3xl mx-auto">
       Planning your dream trip? Let One Zone Travels take the hassle out of visa applications. We offer a wide range of visa services for destinations worldwide. Our experienced consultants will assist you with everything from determining the correct visa type and gathering required documents to submitting your application and tracking its progress. We stay up-to-date on the latest visa regulations, ensuring your application is accurate and complete.    
        </p>
        <div className="mt-4 flex flex-wrap justify-center gap-3">
          <span className="inline-flex items-center px-3 py-1 rounded-full bg-blue-50 text-blue-700 text-sm font-medium">
            <FaGlobe className="mr-2" /> International Visas
          </span>
          <span className="inline-flex items-center px-3 py-1 rounded-full bg-green-50 text-green-700 text-sm font-medium">
            <FaRegClock className="mr-2" /> Fast Processing
          </span>
        </div>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {visaPackages.map((pkg, index) => (
          <motion.div 
            key={`${pkg.country}-${index}`}
            whileHover={{ y: -4 }} 
            className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-xl transition-shadow flex flex-col h-full"
          >
            <div className="relative h-48">
              <img
                src={pkg.image}
                alt={pkg.alt}
                className="w-full h-full object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
              <div className="absolute bottom-0 left-0 p-4 w-full">
                <h3 className="text-xl font-bold text-white">{pkg.country}</h3>
                <div className="flex items-center text-white/90 text-sm mt-1">
                  <FaGlobe className="mr-1" />
                  <span>{pkg.visas.length} visa options available</span>
                </div>
              </div>
            </div>
            <div className="p-4 flex-1 flex flex-col justify-between">
              <div className="space-y-3">
                {pkg.visas.slice(0, 2).map((visa, idx) => (
                  <div key={idx} className="border-b border-gray-100 pb-2 last:border-0 last:pb-0">
                    <h4 className="font-medium text-gray-900">{visa.title}</h4>
                    <div className="flex justify-between text-sm text-gray-600">
                      <span>{visa.stay}</span>
                      <span className="flex items-center">
                        <FaRegClock className="mr-1" /> {visa.processing}
                      </span>
                    </div>
                  </div>
                ))}
                {pkg.visas.length > 2 && (
                  <div className="text-sm text-blue-600">
                    +{pkg.visas.length - 2} more options
                  </div>
                )}
              </div>
              <Link
                to="/view-visa-assistance"
                state={{ visaPackage: pkg }}
                className="mt-4 inline-block w-full text-center py-2 px-4 border border-blue-600 text-blue-600 rounded-md hover:bg-blue-50 transition-colors"
              >
                View Details
              </Link>
            </div>
          </motion.div>
        ))}
      </div>

        {/* <section className="mt-12 bg-white rounded-2xl shadow p-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">General Document & Photo Requirements</h2>
          <div className="grid md:grid-cols-2 gap-8">
            <div>
              <h3 className="text-lg font-semibold text-gray-800 mb-3 flex items-center"><FaPassport className="mr-2 text-blue-600" /> Passport Requirements</h3>
              <ul className="space-y-2 text-gray-700 text-sm">
                <li>• Clear picture of passport's front page</li>
                <li>• Clear picture of passport's back page</li>
                <li>• Passport must be valid for at least 6 months</li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-800 mb-3 flex items-center"><FaCamera className="mr-2 text-blue-600" /> Photo Requirements</h3>
              <ul className="space-y-2 text-gray-700 text-sm">
                <li>• Recent color photograph with white background</li>
                <li>• Full face, front view with a neutral expression</li>
                <li>• No headgear except for religious reasons</li>
              </ul>
            </div>
          </div>

          <div className="mt-6 p-4 bg-yellow-50 border-l-4 border-yellow-400 rounded">
            <p className="text-sm text-yellow-800">• A minor's visa must be applied along with the parent's visa application. Birth certificate is required for minors. Additional documents may be required based on nationality.</p>
          </div>
        </section>

        <div className="mt-10 text-center">
          <button
            onClick={() => navigate('/contact')}
            className="inline-flex items-center px-8 py-3 border border-transparent text-base font-medium rounded-full text-white bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 focus:outline-none"
          >
            Start Your Application
          </button>
        </div> */}
    </section>
  );
};

export default VisaAssistance;
